import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration/configuration.service';
import { NotificationService } from '../services/notification/notification.service';

@Injectable({ providedIn: 'root' })
export class ConfigResolver implements Resolve<unknown> {
  constructor(
    private configService: ConfigurationService,
    private notificationService: NotificationService
  ) {}

  resolve(): Observable<unknown> | Promise<unknown> | unknown {
    this.notificationService.startPolling();
    return this.configService.loadAll();
  }
}
